import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GenaricNotesModule } from '@common/notes/notes.module';
import { HistoryModule } from '@common/remmi-history/history.module';
import { FeatureFlagModule } from '@directive/feature-flag/feature-flag.module';
import { GoogleAddressModule } from '@directive/google-address/google-address.module';
import { ReorderPipeModule } from '@pipes/reorder-pipe/reorder.module';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { ContactPrimeNgModule } from '../contact-primeNg.module';
import { EditOfficeContactComponent } from './edit-office-contact.component';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { DeveloperAgreementModule } from '@modules/my-projects/edit-project/project-edit/developer-agreement-list/developer-agreement/developer-agreement.module';
import { ExternalEoiGenerateModalModule } from '@common/external-eoi-generate-modal/external-eoi-generate-modal.module';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { ContactAlternativeInfoModule } from '../contact-alternative-info/contact-alternative-info.module';

@NgModule({
  declarations: [EditOfficeContactComponent],
  imports: [
    FeatureFlagModule,
    CommonModule,
    ContactPrimeNgModule,
    CommonSharedModule,
    GenaricNotesModule,
    ReorderPipeModule,
    FormsModule,
    ReactiveFormsModule,
    GoogleAddressModule,
    HistoryModule,
    ReMultipleSelectModule,
    DeveloperAgreementModule,
    ReMultiselectModule,
    ExternalEoiGenerateModalModule,
    PipeDirectiveModule,
    ContactAlternativeInfoModule,
  ],
  exports: [EditOfficeContactComponent],
})
export class EditOfficeContactModule {}
